import {makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';
import * as antd from 'antd';

function getVerifySrc() {
    return `${Api.VerifySrc}?date=${new Date().getTime()}`;
}

class ModifyPasswordStore {
    password = '';
    password1 = '';
    password2 = '';
    verifyCode = '';
    verifyImg = getVerifySrc();

    constructor() {
        makeAutoObservable(this)
    }

    init() {
        this.password = '';
        this.password1 = '';
        this.password2 = '';
        this.verifyCode = '';
        this.refreshVerifyImg();
    }

    refreshVerifyImg() {
        this.verifyImg = getVerifySrc();
    }

    async doModify() {
        try {
            const {verifyCode, password, password1, password2} = this;

            if (!password) {
                antd.message.error('请输入原密码');
                return false;
            }
            if (!password1) {
                antd.message.error('请输入新密码');
                return false;
            }
            if (password1 !== password2) {
                antd.message.error('两次输入的密码不一致');
                return false;
            }
            if (!this.verifyCode) {
                antd.message.error('请输入验证码');
                return false;
            }

            await Api.modifyPassword({
                verify: verifyCode,
                password,
                newPassword: password1
            });

            return true;
        } catch (error) {
            antd.message.error(error);
            return false;
        }
    }


}

const store = new ModifyPasswordStore();

export default store;
